import { render } from "./account-header.vue?vue&type=template&id=17279ca5&scoped=true&lang=true"
import script from "./account-header.vue?vue&type=script&lang=js"
export * from "./account-header.vue?vue&type=script&lang=js"

import "./account-header.vue?vue&type=style&index=0&id=17279ca5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17279ca5"]])

export default __exports__